/**
 * Created by divyanshverma on 6/27/15.
 */
var app = angular.module('obto.data.canvas', ['ui.bootstrap']);

app.directive('draw', function () {
    return {
        restrict: 'AEC',
        link: function postLink(scope, element, attrs) {
            var path;
            var drag = false;

            function mouseUp(event) {
                //Clear Mouse Drag Flag
                drag = false;
            }

            function mouseDrag(event) {
                if (drag) {
                    path.add(new paper.Point(event.layerX, event.layerY));
                    path.smooth();
                }
            }

            function mouseDown(event) {
                //Set  flag to detect mouse drag
                drag = true;
                path = new paper.Path();
                path.strokeColor = 'black';
                path.add(new paper.Point(event.layerX, event.layerY));
            }

            function initPaper() {
                paper.install(window);
                paper.setup('canvas');
            }

            element.on('mousedown', mouseDown).on('mouseup', mouseUp).on('mousemove', mouseDrag);

            initPaper();

        }
    };
});

app.controller('canvasController', ['$scope', function ($scope) {

    var cnvs = document.getElementById('canvas');
    var canvasParent = document.getElementById("canvasParent");
    $scope.cvs = cnvs;
    var input, file, fr, img;
    cnvs.style.width = '99%';
    cnvs.style.height = '100%';

    cnvs.width = cnvs.offsetWidth;
    cnvs.height = cnvs.offsetHeight;
    $scope.lecturefile = "";

    $scope.lectures = [{
        description: "Test",
        link: "abc",
        created_on: "12-12-2015"
    }, {
        description: "Test2",
        link: "abc2",
        created_on: "13-12-2015"
    }];

    $scope.$watch("lecturefile", function (n, o) {
        //console.log("lecturefile :" + JSON.stringify($scope.lecturefile));
        if (n !== o) {
            console.log(JSON.stringify($scope.lecturefile));
            img = document.createElement('img');//new Image();
            img.onload = imageLoaded;
            img.src = $scope.lecturefile;
            //img.id = "something"
            //$('#something').draggable();
            //createImage()
        }
    }, true);

    $scope.saveimage = function ($event) {
        var dataURL = cnvs.toDataURL('image/png');
        console.log(dataURL);
    };

    var ctx = cnvs.getContext('2d');
    $scope.ctx = ctx;

    function createImage() {
        //img = new Image();
        ////img.onload = imageLoaded;
        //img.src = fr.result;
        //img.id = "something"
        //$('#something').draggable();
    }

    function imageLoaded() {
        //var canvas = document.getElementById("canvas")
        //cnvs.width = img.width;
        //canvas.height = img.height;
        //var ctx = canvas.getContext("2d");
        $scope.ctx.drawImage(img, 10, 10, img.width, img.height);
        //$scope.ctx.drawImage(imageObj, 30, 15, 130, 110);
        //alert(canvas.toDataURL("image/png"));
    }

    //$scope.loadimage = function (e) {
    //    input = document.getElementById('upload-lecture');
    //    file = input.files[0];
    //    fr = new FileReader();
    //    fr.onload = createImage;
    //    fr.readAsDataURL(file);
    //    //$scope.ctx.drawImage(imageObj, 30, 15, 130, 110);
    //};
    $scope.downloadimage = function (e) {
        var el = event.currentTarget;
        el.download = "drawing.png";
        el.href = cnvs.toDataURL("image/png").replace("image/png", "image/octet-stream");
        //document.location.download = "filename";
        //document.location.href = cnvs.toDataURL("image/png").replace("image/png", "image/octet-stream");

    };

    $scope.selectColor = function (event) {
        var el = event.currentTarget;
        console.log(el);
        for (var i = 0; i < document.getElementsByClassName("palette").length; i++) {
            document.getElementsByClassName("palette")[i].style.borderColor = "#777";
            document.getElementsByClassName("palette")[i].style.borderStyle = "solid";
        }
        el.style.borderColor = "#fff";
        el.style.borderStyle = "dashed";
        color = window.getComputedStyle(el).backgroundColor;
        console.log(color.toString());
        if (color.toString() === "rgb(255, 255, 255)") {
            $scope.ctx.lineWidth = 15;
            $scope.ctx.lineJoin = $scope.ctx.lineCap = 'round';
            console.log("I matched");
        }
        $scope.ctx.beginPath();
        $scope.ctx.strokeStyle = color;
    };

}]);
app.directive("drawing", function () {
    return {
        restrict: "A",
        scope: {},
        link: function (scope, element) {
            var requestAnimationFrame = window.requestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                function(callback){
                    window.setTimeout(callback, 1000/60);
                };
            var canvas = element[0];
            var context = element[0].getContext('2d');
            var penDown = false;
            var lineStarted = false;
            var pos;
            var canvasParent = document.getElementById("canvasParent");
            var touchMode = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
            var downEvent = touchMode ? 'touchstart' : 'mousedown';
            var moveEvent = touchMode ? 'touchmove' : 'mousemove';
            var upEvent = touchMode ? 'touchend' : 'mouseup';
            //context.lineWidth = 15;
            var onDownEvent = function (e) {
                //e.preventDefault();
                penDown = true;
                context.lineWidth = 7;
                if("#ffffff" === context.strokeStyle.toString()){
                    context.lineWidth = 30;
                }
                context.lineJoin = context.lineCap = 'round';
                pos = touchMode ? getTouchPos(e) : getMousePos(e);
                context.beginPath();
                context.moveTo(pos.x, pos.y);
                context.arc(pos.x, pos.y, 1, 0, Math.PI*2);
                context.closePath();
                context.fill();

            };
            var onMoveEvent = function (e) {
                e.preventDefault();
                pos = touchMode ? getTouchPos(e) : getMousePos(e);
                //draw()
                requestAnimationFrame(draw);
            };
            var onUpEvent = function (e) {
                e.preventDefault();
                penDown = false;
                lineStarted = false;
            };

            element.bind(downEvent, onDownEvent);
            element.bind(moveEvent, onMoveEvent);
            element.bind(upEvent, onUpEvent);

            function draw(){

                if (!penDown)
                    return;

                context.lineTo(pos.x, pos.y);
                context.stroke();
                //requestAnimationFrame(draw);
                //if (!lineStarted) {
                //    context.beginPath();
                //    context.moveTo(pos.x, pos.y);
                //    lineStarted = true;
                //} else {
                //    context.lineTo(pos.x, pos.y);
                //    context.stroke();
                //}
            }

            function getTouchPos(e) {
                var rect = canvas.getBoundingClientRect();
                var touch = e.originalEvent.changedTouches[0];
                return {
                    x: touch.pageX - rect.left - document.body.scrollLeft,
                    y: touch.pageY - rect.top - document.body.scrollTop
                };

            }

            function getMousePos(e) {
                var rect = canvas.getBoundingClientRect();
                return {
                    x: e.clientX - rect.left,
                    y: e.clientY - rect.top
                };
            }

            //$(window).bind('scroll', function () {
            //    //canvas.calcOffset.bind(canvas);
            //    //canvas.calcOffset();
            //    console.log(document.body.scrollTop + " : " + document.body.scrollLeft);
            //});

            $('#canvasParent').bind('resize', function () {
                console.log('resized1');
                var imgData = context.getImageData(0, 0, canvas.width, canvas.height);
                canvas.width = (canvas.offsetWidth);
                canvas.height = (canvas.offsetHeight);
                context.putImageData(imgData, 0, 0);
            });

            //$(window).resize(function () {
            //    console.log('resized2');
            //    var imgData = context.getImageData(0, 0, canvas.width, canvas.height);
            //    canvas.width = (canvas.offsetWidth);
            //    canvas.height = (canvas.offsetHeight);
            //    context.putImageData(imgData, 0, 0);
            //});
        }
    };
});
app.directive('smartJquiAccordion', function ($compile) {
    return {
        restrict: 'A',
        //transclude: true,
        //template: '<ng-transclude></ng-transclude>',
        link: function (scope, element, attributes) {

            element.accordion({
                autoHeight: false,
                heightStyle: "content",
                collapsible: true,
                animate: 300,
                icons: {
                    header: "fa fa-plus",    // custom icon class
                    activeHeader: "fa fa-minus" // custom icon class
                },
                header: "h4"
            });
            $compile(element.contents())(scope);
        }
    };
});
app.directive('oldLectures', function ($compile, pageService, $http, $rootScope, moment) {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
            lectures: '=',
        },
        controller: function () {

            //console.log('POST' + $scope.collection);
            //console.log('POST' + $scope.document);
            //console.log('POST' + $scope.csrf);
        },
        template: '<div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="well well-sm well-light"><h3>Previous Lectures' +
        '</h3><ng-transclude></ng-transclude></div></div>',
        link: function (scope, element) {

        }
    };
});

export default app;
